import { TranslationKey } from './../translation/TranslationKey';

import { cloneDeep } from '@apollo/client/utilities';
import { CompanyEntity, forCreate, forDelete, forUpdate } from '../common/entity';
import { TableSettingsColumn } from '../tableSettings';
import { t } from '../translation/Translator';

export enum AssetTransactionColumn {
  productName = 'productName',
  productNumber = 'productNumber',
  quantity = 'quantity',
  status = 'status',
  assignedTo = 'assignedTo',
  sign = 'sign',
  signedAt = 'signedAt',
  pendingQuantity = 'pendingQuantity',
  createdAt = 'createdAt',
  serial = 'serial',
}

export class AssetTransactionTableSettings extends CompanyEntity {
  columns: AssetTransactionTableColumn[] = defaultAssetTransactionTable;
  userId?: string;

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, cloneDeep(obj));
  }

  forUpdate(): UpdateAssetTransactionTableSettingsInput {
    return UpdateAssetTransactionTableSettingsInput.from(this, UpdateAssetTransactionTableSettingsInput);
  }

  forDelete(): DeleteAssetTransactionTableSettingsInput {
    return DeleteAssetTransactionTableSettingsInput.from(this, DeleteAssetTransactionTableSettingsInput);
  }

  validate() {
    return this.validateEntity(
      Object.getOwnPropertyNames(this) as (keyof AssetTransactionTableSettings)[],
      (field: keyof AssetTransactionTableSettings) => {
        return null;
      },
    );
  }
}

export class CreateAssetTransactionTableSettingsInput extends forCreate(AssetTransactionTableSettings) {}

export class UpdateAssetTransactionTableSettingsInput extends forUpdate(AssetTransactionTableSettings) {}

export class DeleteAssetTransactionTableSettingsInput extends forDelete(AssetTransactionTableSettings) {}

export class AssetTransactionTableColumn implements TableSettingsColumn<AssetTransactionColumn> {
  index: number;
  column: string;
  label: string;

  constructor(index: number, column: string, label: string) {
    this.index = index;
    this.column = column;
    this.label = label;
  }
}

export const defaultAssetTransactionTable: AssetTransactionTableColumn[] = [
  {
    index: 0,
    column: AssetTransactionColumn.productName,
    label: t(TranslationKey.productName).singular.label,
  },
  {
    index: 1,
    column: AssetTransactionColumn.productNumber,
    label: t(TranslationKey.productNumber).singular.label,
  },
  {
    index: 2,
    column: AssetTransactionColumn.quantity,
    label: t(TranslationKey.quantity).singular.label,
  },
];

export function assetTransactionColumnToString(col: string) {
  switch (col) {
    case AssetTransactionColumn.productName:
      return t(TranslationKey.productName).singular.label;
    case AssetTransactionColumn.productNumber:
      return t(TranslationKey.productNumber).singular.label;
    case AssetTransactionColumn.quantity:
      return t(TranslationKey.quantity).singular.label;
  }
  return col;
}

export function stringToAssetTransactionColumn(col: string) {
  switch (col) {
    case t(TranslationKey.productName).singular.label:
      return AssetTransactionColumn.productName;
    case t(TranslationKey.productNumber).singular.label:
      return AssetTransactionColumn.productNumber;
    case t(TranslationKey.quantity).singular.label:
      return AssetTransactionColumn.quantity;
  }
  return col;
}
